import axios from 'axios';
import { useState, useEffect } from 'react';

import { getUsedFormProps } from './helpers';

function buildSubmitUrl(form) {
  const { portalId, guid } = form || {};
  return `https://api.hsforms.com/submissions/v3/integration/submit/${portalId}/${guid}/`;
}

const endpointBasePath = process.env.NEXT_PUBLIC_BASE_PATH || '';

export function useHubspotForm(formId) {
  const [form, setForm] = useState(null);

  useEffect(() => {
    async function getForm() {
      const { data } = await axios.post(`${endpointBasePath}/api/getform/${formId}`);

      setForm(data);
    }
    if (formId) {
      getForm();
    }
    return () => {
      setForm(null);
    };
  }, [formId]);

  return {
    isLoading: form === null,
    ...getUsedFormProps(form),
    hasRedirect: (form?.redirect || '').length > 0,
    submitUrl: buildSubmitUrl(form),
  };
}
